import React from 'react'
import { getFilenameWithoutTimestamp } from 'components/Cms/Block/Blocks/utils'
import { FileFormatDocIcon } from 'redesign/components/atoms/Icon'
import { ICON_SIZE } from 'redesign/components/atoms/Icon/constants'
import ContentCard from 'redesign/components/organisms/content-card'
import { DOCUMENT_CARD_IDS } from 'redesign/components/templates/ContentLists/Documents/constants'
import type { CmsDocumentBlockProps } from './types'
import useCmsDocumentBlock from './use-cms-document-block'

const CmsContentDocumentBlock: React.FC<CmsDocumentBlockProps> = (props) => {
  const { filename, filesize, viewFile } = useCmsDocumentBlock(props)

  return (
    <ContentCard
      dataTestId={DOCUMENT_CARD_IDS.document}
      dotDataTestId="status-received"
      onClick={viewFile}
      header={{
        icon: <FileFormatDocIcon size={ICON_SIZE.large} />,
        title: getFilenameWithoutTimestamp({ filename }),
        titleTestId: 'document-title',
        subtitle: filesize ?? '',
        showChevron: true,
      }}
    />
  )
}

export default CmsContentDocumentBlock
